import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function EcommerceServies() {
    const features = [
        {
            title: 'Custom E-commerce Development',
            description:
                'Our e-commerce website design and development services craft a superior online shopping experience resonating with your consumers. Harness high-performance e-commerce infrastructures and user interfaces for high conversions with our expertise.',
            icon: '/img/technology/ic-development.svg',
        },
        {
            title: 'Platform-based E-commerce Development',
            description:
                'We offer a robust foundation for your online store\'s success using platform-based e-commerce development services. Our developers use top e-commerce platforms like Shopify, WooCommerce, Magento, and BigCommerce to create custom e-commerce solutions.',
            icon: '/img/technology/ic-custom-app-development.svg',
        },
        {
            title: 'Mobile E-commerce App Development',
            description:
                'Using our mobile e-commerce app development services cater to the mobile-savvy consumer. We craft apps that enhance your online store\'s accessibility, offering seamless shopping experiences on smartphones and tablets.',
            icon: '/img/technology/ic-mobile-ecommerce.svg',
        },
        {
            title: 'E-commerce Website Design',
            description:
                'Our e-commerce website design services are dedicated to creating visually captivating and highly functional online stores. We know that a well-designed e-commerce website is not just about aesthetics; it\'s a strategic tool for attracting and retaining customers.',
            icon: '/img/technology/ic_portaldevelopment.svg',
        },
        {
            title: 'E-commerce Consulting',
            description:
                'With our e-commerce consulting services, you get valuable guidance and strategic insights to navigate your business seamlessly in the complex world of online retail. Our experts offer tailored advice to optimize your e-commerce strategy and achieve sustainable growth.',
            icon: '/img/technology/ic-consulting-services.svg',
        },
        {
            title: 'E-commerce Integrations',
            description:
                'Our e-commerce Integration Services seamlessly connect your online store with essential tools and systems like payment gateways, inventory management, CRM platforms, and more. Our e-commerce developers enhance efficiency and provide a unified shopping experience for your customers.',
            icon: '/img/technology/ic-integration.svg',
        },
        {
            title: 'E-commerce Store Migration',
            description:
                'Leverage our e-commerce migration services to seamlessly transition your online store to a new platform or environment. We handle the complex process to ensure a smooth move, safeguarding your data, and minimizing downtime.',
            icon: '/img/technology/ic-shopify-store-design.svg',
        },
        {
            title: 'E-commerce Support and Evolution',
            description:
                'Our e-commerce support and evolution services ensure your online business stays strong and adaptable. We provide ongoing assistance and strategic evolution to keep your e-commerce venture thriving in an ever-changing digital landscape.',
            icon: '/img/technology/ic-support-maintenance.svg',
        },
        {
            title: 'E-commerce UX/UI App Design',
            description:
                'Our e-commerce UX/UI app design services focus on creating an exceptional user experience that drives engagement and conversions. With intuitive, visually appealing e-commerce web design interfaces make online shopping a breeze for your customers.',
            icon: '/img/technology/ic-ios-uiux.svg',
        },
    ];

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                E-commerce Development Services
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid features={features} variant="grey" />
                </div>
            </div>
        </>
    );
}

export default EcommerceServies;
